import React, { useState } from "react";
import styles from "../Casefile.module.scss";
import CloseButton from "./CloseButton";

import { Link } from "@reach/router";

function AntTwo(props) {
  return (
    <div className={styles.queryBox}>
      <CloseButton setSelected={props.setSelected} />
      <div className={styles.questions}>
        <p>We ants are just making do here in Ropewalks Square.</p>
        <p>
          We live around this tree and make the most of the food that the humans
          drop, cans of fizzy drinks, crisps, sandwiches all tasty, but it’s all
          concrete around here. Can you write an incident report, telling the
          humans that we URGENTLY need more green things in this square so we
          can get building.{" "}
        </p>
      </div>
    </div>
  );
}

export default AntTwo;
